import { Injectable } from '@angular/core';
import { IEnvironment } from '../../environments/environment.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService implements IEnvironment {
  get providerAppUrl() {
    return environment.providerAppUrl;
  }

  get adminApiUrl() {
    return environment.adminApiUrl;
  }

  get appUrl() {
    return environment.appUrl;
  }

  get name() {
    return environment.name;
  }

  get production() {
    return environment.production;
  }
  get msalClientId() {
    return environment.msalClientId;
  }

  get msalAuthority() {
    return environment.msalAuthority;
  }

  get registrantGroup() {
    return environment.registrantGroup;
  }

  get enrollmentToken() {
    return environment.enrollmentToken;
  }

  get metabaseInstanceUrl() {
    return environment.metabaseInstanceUrl;
  }

  get instrumentationKey() {
    return environment.instrumentationKey;
  }

  get app() {
    return environment.app;
  }

  get apiMode() {
    return environment.apiMode;
  }

  get apiUrls() {
    return environment.apiUrls;
  }
}
